"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaQuery = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useMediaQuery = function useMediaQuery(query) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleMQChange = function handleMQChange(_ref) {
      var matches = _ref.matches;
      return setMatches(matches);
    };

    var result = window.matchMedia(query);

    try {
      result.addEventListener('change', handleMQChange);
    } catch (_unused) {
      try {
        result.addListener(handleMQChange);
      } catch (e) {
        console.error(e);
      }
    }

    setMatches(result.matches);
    return function () {
      try {
        result.removeEventListener('change', handleMQChange);
      } catch (_unused2) {
        try {
          result.removeListener(handleMQChange);
        } catch (e) {
          console.error(e);
        }
      }
    };
  }, [query]);
  return matches;
};

exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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